import { render } from "./RolesEdit.vue?vue&type=template&id=5af3b7d8"
import script from "./RolesEdit.vue?vue&type=script&lang=js"
export * from "./RolesEdit.vue?vue&type=script&lang=js"

import "./RolesEdit.vue?vue&type=style&index=0&id=5af3b7d8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__